import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Form } from 'react-bootstrap'
import { Row } from '_zari/core'

/**
 * @param {{
 *    className?: string
 * }} props
 * @returns {React.Component}
 */
const ZariFormGroup = ({ className, children }) => {
  return (
    <Form.Group as={Row} className={clsx('zari-formgroup', className)}>
      {children}
    </Form.Group>
  )
}

ZariFormGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
}

export default ZariFormGroup
